// App.jsx
import Canvas from "./Canvas.jsx";
// import image from "./assets/images2.jpeg";

export default function ThreeJsMain() {
  return (
    <div
      style={{
        background: "black",
        backgroundImage:
          "radial-gradient(white 1px, transparent 1px), radial-gradient(black 1px, transparent 1px)",
        backgroundSize: "20px 20px",
        backgroundPosition: "0 0, 10px 10px",
      }}
      className="pt-10 "
    >
      <div>
        <h1 className="text-white pl-8 text-[25px] "> Overview :</h1>
      </div>

      <div
        style={{
          height: "90vh",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "black",
          backgroundImage:
            "radial-gradient(white 1px, transparent 1px), radial-gradient(black 1px, transparent 1px)",
          backgroundSize: "20px 20px",
          backgroundPosition: "0 0, 10px 10px",
        }}
      >
        <div style={{ width: "80vw", height: "90vh" }}>
          <Canvas />
        </div>
      </div>
    </div>
  );
}
